<template>

  <FadeIn class="relative overflow-hidden py-16">
    <div class="prose relative bg-[#e8e5de] !p-6 rounded-lg">
      <h2 class="!mt-0 !mb-6 text-xl font-semibold">{{ content.title }}</h2>
      <div class="relative not-prose">
        <div v-for="(faq, index) in content.faqs"
             class="border-2 border-[#d7d4cd] hover:border-[#5a6ded] transition bg-white rounded-xl mb-4 duration-200"
             :key="index">
          <button
            @click="togglePanel(index)"
            class="pointer py-4 md:py-6 w-full text-left"
            :aria-expanded="activePanel === index"
            :aria-controls="`inline-faq-content-${index}`"
            :aria-label="`Toggle FAQ: ${faq.faq_item_id.question}`"
          >
            <div class="flex w-full items-start justify-between text-left items-center">
              <div class="text-base font-semibold leading-6 w-[calc(100%-4rem)] lg:text-lg px-4">
                {{ faq.faq_item_id.question }}
              </div>
              <div class="mr-4 bg-[#5a6ded] border-2 border-[#3645d0] rounded w-8 h-8 flex items-center justify-center">
                <Icon name="ph:caret-down" v-if="activePanel !== index" class="h-6 w-6 text-[#fff]" />
                <Icon name="ph:caret-up" v-else class="h-6 w-6 text-[#fff]" />
              </div>
            </div>
          </button>
          <div
            v-show="activePanel === index"
            class="prose"
            :id="`inline-faq-content-${index}`"
            role="region"
          >
            <div class="text-base px-4 pb-4 faq__a"
            v-interpolation
            v-html="useSanitize(faq.faq_item_id.answer, currentLocale)"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </FadeIn>

</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  }
})

const activePanel = ref(999)

const togglePanel = index => {
  activePanel.value = activePanel.value === index ? 999 : index
}

const route = useRoute()
const currentLocale = computed(() => {
  return route.path.startsWith('/nz') ? 'nz' : 'au'
})

// FAQPage JSON-LD schema for article-inline FAQs. Matches the schema
// emitted by Block/Faqs.vue so article FAQs contribute to rich results.
if (props.content?.faqs?.length > 0) {
  const schemaItems = [
    defineWebPage({
      '@type': 'FAQPage',
    }),
    ...props.content.faqs.map(faq =>
      defineQuestion({
        name: faq.faq_item_id.question,
        acceptedAnswer: faq.faq_item_id.answer
      })
    )
  ]

  useSchemaOrg(schemaItems)
}
</script>
